/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_TipsInputs */



/**
* | output |
* | --- |
* | "Close Tips" |
*
* @param {Close_TipsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_tips = /** @type {((inputs?: Close_TipsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_TipsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer les nouveautés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tipps schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi Suggerimenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Советы по закрытию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Consejos para cerrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("温馨提示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ヒントを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बंद करने के सुझाव")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dicas de fechamento")
	return /** @type {LocalizedString} */ ("Close Tips")
});